module.exports = __webpack_public_path__ + "static/img/17.13d93a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/17.png
// module id = 0Bll
// module chunks = 0